import { http } from './config'

export default {
  listandoordem:(orde) => {
    return http.get('nome_ordens.php?cd_prod='+orde)
  },
  verificaordem:(cd) => {
    return http.get('nome_ordem_selecao.php?cd_prod='+cd)
  }
}